/**
 * 환경변수는 두 가지 경로로 주입됨:
 * 1. htmlEnvInjectionPlugin → window.* (런타임, VITE_ prefix 제거)
 * 2. import.meta.env.VITE_* (빌드타임)
 *
 * window.* 를 우선 참조하고, fallback으로 import.meta.env 사용
 */

declare global {
  interface Window {
    ENV?: string;
    PROJECT?: string;
    API_ENDPOINT?: string;
    HOST?: string;
    WEB_HOST?: string;
    ADMIN_HOST?: string;
    GOOGLE_CLIENT_ID?: string;
  }
}

export const ENV = window.ENV || import.meta.env.VITE_ENV || 'LOCAL';
export const PROJECT = window.PROJECT || import.meta.env.VITE_PROJECT || '';
export const API_ENDPOINT =
  window.API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT || '';
export const HOST = window.HOST || import.meta.env.VITE_HOST || '';
export const WEB_HOST = window.WEB_HOST || import.meta.env.VITE_WEB_HOST || '';
export const ADMIN_HOST =
  window.ADMIN_HOST || import.meta.env.VITE_ADMIN_HOST || '';
export const GOOGLE_CLIENT_ID =
  window.GOOGLE_CLIENT_ID || import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
export const IS_DEV = ENV === 'LOCAL' || ENV === 'DEV';
export const IS_PROD = ENV === 'PROD';
